/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Hallx = (function() {

    /**
     * Namespace Hallx.
     * @exports Hallx
     * @namespace
     */
    var Hallx = {};

    Hallx.IdlePingReq = (function() {

        /**
         * Properties of an IdlePingReq.
         * @memberof Hallx
         * @interface IIdlePingReq
         */

        /**
         * Constructs a new IdlePingReq.
         * @memberof Hallx
         * @classdesc 空闲心跳请求，7秒一次，仅在空闲无发包时发送
         * @implements IIdlePingReq
         * @constructor
         * @param {Hallx.IIdlePingReq=} [properties] Properties to set
         */
        function IdlePingReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new IdlePingReq instance using the specified properties.
         * @function create
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {Hallx.IIdlePingReq=} [properties] Properties to set
         * @returns {Hallx.IdlePingReq} IdlePingReq instance
         */
        IdlePingReq.create = function create(properties) {
            return new IdlePingReq(properties);
        };

        /**
         * Encodes the specified IdlePingReq message. Does not implicitly {@link Hallx.IdlePingReq.verify|verify} messages.
         * @function encode
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {Hallx.IIdlePingReq} message IdlePingReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IdlePingReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified IdlePingReq message, length delimited. Does not implicitly {@link Hallx.IdlePingReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {Hallx.IIdlePingReq} message IdlePingReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IdlePingReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IdlePingReq message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.IdlePingReq} IdlePingReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IdlePingReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.IdlePingReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IdlePingReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.IdlePingReq} IdlePingReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IdlePingReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IdlePingReq message.
         * @function verify
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IdlePingReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an IdlePingReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.IdlePingReq} IdlePingReq
         */
        IdlePingReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.IdlePingReq)
                return object;
            return new $root.Hallx.IdlePingReq();
        };

        /**
         * Creates a plain object from an IdlePingReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.IdlePingReq
         * @static
         * @param {Hallx.IdlePingReq} message IdlePingReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IdlePingReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this IdlePingReq to JSON.
         * @function toJSON
         * @memberof Hallx.IdlePingReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IdlePingReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IdlePingReq;
    })();

    Hallx.IdlePingRsp = (function() {

        /**
         * Properties of an IdlePingRsp.
         * @memberof Hallx
         * @interface IIdlePingRsp
         */

        /**
         * Constructs a new IdlePingRsp.
         * @memberof Hallx
         * @classdesc 空闲心跳响应
         * @implements IIdlePingRsp
         * @constructor
         * @param {Hallx.IIdlePingRsp=} [properties] Properties to set
         */
        function IdlePingRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new IdlePingRsp instance using the specified properties.
         * @function create
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {Hallx.IIdlePingRsp=} [properties] Properties to set
         * @returns {Hallx.IdlePingRsp} IdlePingRsp instance
         */
        IdlePingRsp.create = function create(properties) {
            return new IdlePingRsp(properties);
        };

        /**
         * Encodes the specified IdlePingRsp message. Does not implicitly {@link Hallx.IdlePingRsp.verify|verify} messages.
         * @function encode
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {Hallx.IIdlePingRsp} message IdlePingRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IdlePingRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified IdlePingRsp message, length delimited. Does not implicitly {@link Hallx.IdlePingRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {Hallx.IIdlePingRsp} message IdlePingRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IdlePingRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IdlePingRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.IdlePingRsp} IdlePingRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IdlePingRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.IdlePingRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IdlePingRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.IdlePingRsp} IdlePingRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IdlePingRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IdlePingRsp message.
         * @function verify
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IdlePingRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an IdlePingRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.IdlePingRsp} IdlePingRsp
         */
        IdlePingRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.IdlePingRsp)
                return object;
            return new $root.Hallx.IdlePingRsp();
        };

        /**
         * Creates a plain object from an IdlePingRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.IdlePingRsp
         * @static
         * @param {Hallx.IdlePingRsp} message IdlePingRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IdlePingRsp.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this IdlePingRsp to JSON.
         * @function toJSON
         * @memberof Hallx.IdlePingRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IdlePingRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IdlePingRsp;
    })();

    Hallx.AuthReq = (function() {

        /**
         * Properties of an AuthReq.
         * @memberof Hallx
         * @interface IAuthReq
         * @property {number} playerId AuthReq playerId
         * @property {string} token AuthReq token
         * @property {string|null} [gameId] AuthReq gameId
         * @property {number|null} [clubId] AuthReq clubId
         */

        /**
         * Constructs a new AuthReq.
         * @memberof Hallx
         * @classdesc 建立连接认证请求,gameId、clubId二选一，俱乐部大厅传clubId，娱乐场大厅传gameId
         * @implements IAuthReq
         * @constructor
         * @param {Hallx.IAuthReq=} [properties] Properties to set
         */
        function AuthReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuthReq playerId.
         * @member {number} playerId
         * @memberof Hallx.AuthReq
         * @instance
         */
        AuthReq.prototype.playerId = 0;

        /**
         * AuthReq token.
         * @member {string} token
         * @memberof Hallx.AuthReq
         * @instance
         */
        AuthReq.prototype.token = "";

        /**
         * AuthReq gameId.
         * @member {string} gameId
         * @memberof Hallx.AuthReq
         * @instance
         */
        AuthReq.prototype.gameId = "";

        /**
         * AuthReq clubId.
         * @member {number} clubId
         * @memberof Hallx.AuthReq
         * @instance
         */
        AuthReq.prototype.clubId = 0;

        /**
         * Creates a new AuthReq instance using the specified properties.
         * @function create
         * @memberof Hallx.AuthReq
         * @static
         * @param {Hallx.IAuthReq=} [properties] Properties to set
         * @returns {Hallx.AuthReq} AuthReq instance
         */
        AuthReq.create = function create(properties) {
            return new AuthReq(properties);
        };

        /**
         * Encodes the specified AuthReq message. Does not implicitly {@link Hallx.AuthReq.verify|verify} messages.
         * @function encode
         * @memberof Hallx.AuthReq
         * @static
         * @param {Hallx.IAuthReq} message AuthReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuthReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gameId);
            if (message.clubId != null && message.hasOwnProperty("clubId"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.clubId);
            return writer;
        };

        /**
         * Encodes the specified AuthReq message, length delimited. Does not implicitly {@link Hallx.AuthReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.AuthReq
         * @static
         * @param {Hallx.IAuthReq} message AuthReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuthReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AuthReq message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.AuthReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.AuthReq} AuthReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuthReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.AuthReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.token = reader.string();
                    break;
                case 3:
                    message.gameId = reader.string();
                    break;
                case 4:
                    message.clubId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("token"))
                throw $util.ProtocolError("missing required 'token'", { instance: message });
            return message;
        };

        /**
         * Decodes an AuthReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.AuthReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.AuthReq} AuthReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuthReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AuthReq message.
         * @function verify
         * @memberof Hallx.AuthReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AuthReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isString(message.token))
                return "token: string expected";
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                if (!$util.isString(message.gameId))
                    return "gameId: string expected";
            if (message.clubId != null && message.hasOwnProperty("clubId"))
                if (!$util.isInteger(message.clubId))
                    return "clubId: integer expected";
            return null;
        };

        /**
         * Creates an AuthReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.AuthReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.AuthReq} AuthReq
         */
        AuthReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.AuthReq)
                return object;
            var message = new $root.Hallx.AuthReq();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.token != null)
                message.token = String(object.token);
            if (object.gameId != null)
                message.gameId = String(object.gameId);
            if (object.clubId != null)
                message.clubId = object.clubId | 0;
            return message;
        };

        /**
         * Creates a plain object from an AuthReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.AuthReq
         * @static
         * @param {Hallx.AuthReq} message AuthReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuthReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.token = "";
                object.gameId = "";
                object.clubId = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                object.gameId = message.gameId;
            if (message.clubId != null && message.hasOwnProperty("clubId"))
                object.clubId = message.clubId;
            return object;
        };

        /**
         * Converts this AuthReq to JSON.
         * @function toJSON
         * @memberof Hallx.AuthReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuthReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AuthReq;
    })();

    Hallx.AuthRsp = (function() {

        /**
         * Properties of an AuthRsp.
         * @memberof Hallx
         * @interface IAuthRsp
         * @property {number} code AuthRsp code
         * @property {string|null} [msg] AuthRsp msg
         */

        /**
         * Constructs a new AuthRsp.
         * @memberof Hallx
         * @classdesc 建立连接认证响应
         * @implements IAuthRsp
         * @constructor
         * @param {Hallx.IAuthRsp=} [properties] Properties to set
         */
        function AuthRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AuthRsp code.
         * @member {number} code
         * @memberof Hallx.AuthRsp
         * @instance
         */
        AuthRsp.prototype.code = 0;

        /**
         * AuthRsp msg.
         * @member {string} msg
         * @memberof Hallx.AuthRsp
         * @instance
         */
        AuthRsp.prototype.msg = "";

        /**
         * Creates a new AuthRsp instance using the specified properties.
         * @function create
         * @memberof Hallx.AuthRsp
         * @static
         * @param {Hallx.IAuthRsp=} [properties] Properties to set
         * @returns {Hallx.AuthRsp} AuthRsp instance
         */
        AuthRsp.create = function create(properties) {
            return new AuthRsp(properties);
        };

        /**
         * Encodes the specified AuthRsp message. Does not implicitly {@link Hallx.AuthRsp.verify|verify} messages.
         * @function encode
         * @memberof Hallx.AuthRsp
         * @static
         * @param {Hallx.IAuthRsp} message AuthRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuthRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.msg != null && message.hasOwnProperty("msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            return writer;
        };

        /**
         * Encodes the specified AuthRsp message, length delimited. Does not implicitly {@link Hallx.AuthRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.AuthRsp
         * @static
         * @param {Hallx.IAuthRsp} message AuthRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuthRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AuthRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.AuthRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.AuthRsp} AuthRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuthRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.AuthRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.code = reader.int32();
                    break;
                case 2:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("code"))
                throw $util.ProtocolError("missing required 'code'", { instance: message });
            return message;
        };

        /**
         * Decodes an AuthRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.AuthRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.AuthRsp} AuthRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuthRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AuthRsp message.
         * @function verify
         * @memberof Hallx.AuthRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AuthRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.code))
                return "code: integer expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            return null;
        };

        /**
         * Creates an AuthRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.AuthRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.AuthRsp} AuthRsp
         */
        AuthRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.AuthRsp)
                return object;
            var message = new $root.Hallx.AuthRsp();
            if (object.code != null)
                message.code = object.code | 0;
            if (object.msg != null)
                message.msg = String(object.msg);
            return message;
        };

        /**
         * Creates a plain object from an AuthRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.AuthRsp
         * @static
         * @param {Hallx.AuthRsp} message AuthRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AuthRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.code = 0;
                object.msg = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            return object;
        };

        /**
         * Converts this AuthRsp to JSON.
         * @function toJSON
         * @memberof Hallx.AuthRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AuthRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AuthRsp;
    })();

    Hallx.GameResultItem = (function() {

        /**
         * Properties of a GameResultItem.
         * @memberof Hallx
         * @interface IGameResultItem
         * @property {number} roundNo GameResultItem roundNo
         * @property {string} result GameResultItem result
         */

        /**
         * Constructs a new GameResultItem.
         * @memberof Hallx
         * @classdesc 一局游戏结果
         * @implements IGameResultItem
         * @constructor
         * @param {Hallx.IGameResultItem=} [properties] Properties to set
         */
        function GameResultItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameResultItem roundNo.
         * @member {number} roundNo
         * @memberof Hallx.GameResultItem
         * @instance
         */
        GameResultItem.prototype.roundNo = 0;

        /**
         * GameResultItem result.
         * @member {string} result
         * @memberof Hallx.GameResultItem
         * @instance
         */
        GameResultItem.prototype.result = "";

        /**
         * Creates a new GameResultItem instance using the specified properties.
         * @function create
         * @memberof Hallx.GameResultItem
         * @static
         * @param {Hallx.IGameResultItem=} [properties] Properties to set
         * @returns {Hallx.GameResultItem} GameResultItem instance
         */
        GameResultItem.create = function create(properties) {
            return new GameResultItem(properties);
        };

        /**
         * Encodes the specified GameResultItem message. Does not implicitly {@link Hallx.GameResultItem.verify|verify} messages.
         * @function encode
         * @memberof Hallx.GameResultItem
         * @static
         * @param {Hallx.IGameResultItem} message GameResultItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameResultItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roundNo);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.result);
            return writer;
        };

        /**
         * Encodes the specified GameResultItem message, length delimited. Does not implicitly {@link Hallx.GameResultItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.GameResultItem
         * @static
         * @param {Hallx.IGameResultItem} message GameResultItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameResultItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameResultItem message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.GameResultItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.GameResultItem} GameResultItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameResultItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.GameResultItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roundNo = reader.int32();
                    break;
                case 2:
                    message.result = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("roundNo"))
                throw $util.ProtocolError("missing required 'roundNo'", { instance: message });
            if (!message.hasOwnProperty("result"))
                throw $util.ProtocolError("missing required 'result'", { instance: message });
            return message;
        };

        /**
         * Decodes a GameResultItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.GameResultItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.GameResultItem} GameResultItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameResultItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameResultItem message.
         * @function verify
         * @memberof Hallx.GameResultItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameResultItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.roundNo))
                return "roundNo: integer expected";
            if (!$util.isString(message.result))
                return "result: string expected";
            return null;
        };

        /**
         * Creates a GameResultItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.GameResultItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.GameResultItem} GameResultItem
         */
        GameResultItem.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.GameResultItem)
                return object;
            var message = new $root.Hallx.GameResultItem();
            if (object.roundNo != null)
                message.roundNo = object.roundNo | 0;
            if (object.result != null)
                message.result = String(object.result);
            return message;
        };

        /**
         * Creates a plain object from a GameResultItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.GameResultItem
         * @static
         * @param {Hallx.GameResultItem} message GameResultItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameResultItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roundNo = 0;
                object.result = "";
            }
            if (message.roundNo != null && message.hasOwnProperty("roundNo"))
                object.roundNo = message.roundNo;
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = message.result;
            return object;
        };

        /**
         * Converts this GameResultItem to JSON.
         * @function toJSON
         * @memberof Hallx.GameResultItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameResultItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameResultItem;
    })();

    Hallx.PlayerInfo = (function() {

        /**
         * Properties of a PlayerInfo.
         * @memberof Hallx
         * @interface IPlayerInfo
         * @property {number} id PlayerInfo id
         * @property {number|null} [seatSeq] PlayerInfo seatSeq
         * @property {string|null} [avatar] PlayerInfo avatar
         * @property {string|null} [nickname] PlayerInfo nickname
         */

        /**
         * Constructs a new PlayerInfo.
         * @memberof Hallx
         * @classdesc 玩家信息
         * @implements IPlayerInfo
         * @constructor
         * @param {Hallx.IPlayerInfo=} [properties] Properties to set
         */
        function PlayerInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlayerInfo id.
         * @member {number} id
         * @memberof Hallx.PlayerInfo
         * @instance
         */
        PlayerInfo.prototype.id = 0;

        /**
         * PlayerInfo seatSeq.
         * @member {number} seatSeq
         * @memberof Hallx.PlayerInfo
         * @instance
         */
        PlayerInfo.prototype.seatSeq = 0;

        /**
         * PlayerInfo avatar.
         * @member {string} avatar
         * @memberof Hallx.PlayerInfo
         * @instance
         */
        PlayerInfo.prototype.avatar = "";

        /**
         * PlayerInfo nickname.
         * @member {string} nickname
         * @memberof Hallx.PlayerInfo
         * @instance
         */
        PlayerInfo.prototype.nickname = "";

        /**
         * Creates a new PlayerInfo instance using the specified properties.
         * @function create
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {Hallx.IPlayerInfo=} [properties] Properties to set
         * @returns {Hallx.PlayerInfo} PlayerInfo instance
         */
        PlayerInfo.create = function create(properties) {
            return new PlayerInfo(properties);
        };

        /**
         * Encodes the specified PlayerInfo message. Does not implicitly {@link Hallx.PlayerInfo.verify|verify} messages.
         * @function encode
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {Hallx.IPlayerInfo} message PlayerInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.seatSeq != null && message.hasOwnProperty("seatSeq"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seatSeq);
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
            return writer;
        };

        /**
         * Encodes the specified PlayerInfo message, length delimited. Does not implicitly {@link Hallx.PlayerInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {Hallx.IPlayerInfo} message PlayerInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlayerInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.PlayerInfo} PlayerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.PlayerInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.int32();
                    break;
                case 2:
                    message.seatSeq = reader.int32();
                    break;
                case 3:
                    message.avatar = reader.string();
                    break;
                case 4:
                    message.nickname = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("id"))
                throw $util.ProtocolError("missing required 'id'", { instance: message });
            return message;
        };

        /**
         * Decodes a PlayerInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.PlayerInfo} PlayerInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlayerInfo message.
         * @function verify
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlayerInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.id))
                return "id: integer expected";
            if (message.seatSeq != null && message.hasOwnProperty("seatSeq"))
                if (!$util.isInteger(message.seatSeq))
                    return "seatSeq: integer expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            return null;
        };

        /**
         * Creates a PlayerInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.PlayerInfo} PlayerInfo
         */
        PlayerInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.PlayerInfo)
                return object;
            var message = new $root.Hallx.PlayerInfo();
            if (object.id != null)
                message.id = object.id | 0;
            if (object.seatSeq != null)
                message.seatSeq = object.seatSeq | 0;
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            return message;
        };

        /**
         * Creates a plain object from a PlayerInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.PlayerInfo
         * @static
         * @param {Hallx.PlayerInfo} message PlayerInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlayerInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = 0;
                object.seatSeq = 0;
                object.avatar = "";
                object.nickname = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.seatSeq != null && message.hasOwnProperty("seatSeq"))
                object.seatSeq = message.seatSeq;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            return object;
        };

        /**
         * Converts this PlayerInfo to JSON.
         * @function toJSON
         * @memberof Hallx.PlayerInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlayerInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PlayerInfo;
    })();

    Hallx.RoomStateInfo = (function() {

        /**
         * Properties of a RoomStateInfo.
         * @memberof Hallx
         * @interface IRoomStateInfo
         * @property {number|null} [state] RoomStateInfo state
         * @property {string|null} [stateText] RoomStateInfo stateText
         */

        /**
         * Constructs a new RoomStateInfo.
         * @memberof Hallx
         * @classdesc 房间状态信息
         * @implements IRoomStateInfo
         * @constructor
         * @param {Hallx.IRoomStateInfo=} [properties] Properties to set
         */
        function RoomStateInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomStateInfo state.
         * @member {number} state
         * @memberof Hallx.RoomStateInfo
         * @instance
         */
        RoomStateInfo.prototype.state = 0;

        /**
         * RoomStateInfo stateText.
         * @member {string} stateText
         * @memberof Hallx.RoomStateInfo
         * @instance
         */
        RoomStateInfo.prototype.stateText = "";

        /**
         * Creates a new RoomStateInfo instance using the specified properties.
         * @function create
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {Hallx.IRoomStateInfo=} [properties] Properties to set
         * @returns {Hallx.RoomStateInfo} RoomStateInfo instance
         */
        RoomStateInfo.create = function create(properties) {
            return new RoomStateInfo(properties);
        };

        /**
         * Encodes the specified RoomStateInfo message. Does not implicitly {@link Hallx.RoomStateInfo.verify|verify} messages.
         * @function encode
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {Hallx.IRoomStateInfo} message RoomStateInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomStateInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
            if (message.stateText != null && message.hasOwnProperty("stateText"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.stateText);
            return writer;
        };

        /**
         * Encodes the specified RoomStateInfo message, length delimited. Does not implicitly {@link Hallx.RoomStateInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {Hallx.IRoomStateInfo} message RoomStateInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomStateInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomStateInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.RoomStateInfo} RoomStateInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomStateInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.RoomStateInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.stateText = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomStateInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.RoomStateInfo} RoomStateInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomStateInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomStateInfo message.
         * @function verify
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomStateInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.stateText != null && message.hasOwnProperty("stateText"))
                if (!$util.isString(message.stateText))
                    return "stateText: string expected";
            return null;
        };

        /**
         * Creates a RoomStateInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.RoomStateInfo} RoomStateInfo
         */
        RoomStateInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.RoomStateInfo)
                return object;
            var message = new $root.Hallx.RoomStateInfo();
            if (object.state != null)
                message.state = object.state | 0;
            if (object.stateText != null)
                message.stateText = String(object.stateText);
            return message;
        };

        /**
         * Creates a plain object from a RoomStateInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.RoomStateInfo
         * @static
         * @param {Hallx.RoomStateInfo} message RoomStateInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomStateInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.state = 0;
                object.stateText = "";
            }
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.stateText != null && message.hasOwnProperty("stateText"))
                object.stateText = message.stateText;
            return object;
        };

        /**
         * Converts this RoomStateInfo to JSON.
         * @function toJSON
         * @memberof Hallx.RoomStateInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomStateInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomStateInfo;
    })();

    Hallx.RoomInfo = (function() {

        /**
         * Properties of a RoomInfo.
         * @memberof Hallx
         * @interface IRoomInfo
         * @property {number} id RoomInfo id
         * @property {number|null} [seq] RoomInfo seq
         * @property {number} gameFieldId RoomInfo gameFieldId
         * @property {string|null} [gameId] RoomInfo gameId
         * @property {Hallx.IRoomStateInfo|null} [stateInfo] RoomInfo stateInfo
         * @property {Array.<Hallx.IPlayerInfo>|null} [headPlayers] RoomInfo headPlayers
         * @property {Array.<Hallx.IGameResultItem>|null} [gameResults] RoomInfo gameResults
         * @property {string|null} [extraInfo] RoomInfo extraInfo
         */

        /**
         * Constructs a new RoomInfo.
         * @memberof Hallx
         * @classdesc 房间信息
         * @implements IRoomInfo
         * @constructor
         * @param {Hallx.IRoomInfo=} [properties] Properties to set
         */
        function RoomInfo(properties) {
            this.headPlayers = [];
            this.gameResults = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomInfo id.
         * @member {number} id
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.id = 0;

        /**
         * RoomInfo seq.
         * @member {number} seq
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.seq = 0;

        /**
         * RoomInfo gameFieldId.
         * @member {number} gameFieldId
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.gameFieldId = 0;

        /**
         * RoomInfo gameId.
         * @member {string} gameId
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.gameId = "";

        /**
         * RoomInfo stateInfo.
         * @member {Hallx.IRoomStateInfo|null|undefined} stateInfo
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.stateInfo = null;

        /**
         * RoomInfo headPlayers.
         * @member {Array.<Hallx.IPlayerInfo>} headPlayers
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.headPlayers = $util.emptyArray;

        /**
         * RoomInfo gameResults.
         * @member {Array.<Hallx.IGameResultItem>} gameResults
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.gameResults = $util.emptyArray;

        /**
         * RoomInfo extraInfo.
         * @member {string} extraInfo
         * @memberof Hallx.RoomInfo
         * @instance
         */
        RoomInfo.prototype.extraInfo = "";

        /**
         * Creates a new RoomInfo instance using the specified properties.
         * @function create
         * @memberof Hallx.RoomInfo
         * @static
         * @param {Hallx.IRoomInfo=} [properties] Properties to set
         * @returns {Hallx.RoomInfo} RoomInfo instance
         */
        RoomInfo.create = function create(properties) {
            return new RoomInfo(properties);
        };

        /**
         * Encodes the specified RoomInfo message. Does not implicitly {@link Hallx.RoomInfo.verify|verify} messages.
         * @function encode
         * @memberof Hallx.RoomInfo
         * @static
         * @param {Hallx.IRoomInfo} message RoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
            if (message.seq != null && message.hasOwnProperty("seq"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seq);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.gameFieldId);
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.gameId);
            if (message.stateInfo != null && message.hasOwnProperty("stateInfo"))
                $root.Hallx.RoomStateInfo.encode(message.stateInfo, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.headPlayers != null && message.headPlayers.length)
                for (var i = 0; i < message.headPlayers.length; ++i)
                    $root.Hallx.PlayerInfo.encode(message.headPlayers[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.gameResults != null && message.gameResults.length)
                for (var i = 0; i < message.gameResults.length; ++i)
                    $root.Hallx.GameResultItem.encode(message.gameResults[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.extraInfo != null && message.hasOwnProperty("extraInfo"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.extraInfo);
            return writer;
        };

        /**
         * Encodes the specified RoomInfo message, length delimited. Does not implicitly {@link Hallx.RoomInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.RoomInfo
         * @static
         * @param {Hallx.IRoomInfo} message RoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.RoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.RoomInfo} RoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.RoomInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.int32();
                    break;
                case 2:
                    message.seq = reader.int32();
                    break;
                case 3:
                    message.gameFieldId = reader.int32();
                    break;
                case 4:
                    message.gameId = reader.string();
                    break;
                case 13:
                    message.stateInfo = $root.Hallx.RoomStateInfo.decode(reader, reader.uint32());
                    break;
                case 14:
                    if (!(message.headPlayers && message.headPlayers.length))
                        message.headPlayers = [];
                    message.headPlayers.push($root.Hallx.PlayerInfo.decode(reader, reader.uint32()));
                    break;
                case 15:
                    if (!(message.gameResults && message.gameResults.length))
                        message.gameResults = [];
                    message.gameResults.push($root.Hallx.GameResultItem.decode(reader, reader.uint32()));
                    break;
                case 16:
                    message.extraInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("id"))
                throw $util.ProtocolError("missing required 'id'", { instance: message });
            if (!message.hasOwnProperty("gameFieldId"))
                throw $util.ProtocolError("missing required 'gameFieldId'", { instance: message });
            return message;
        };

        /**
         * Decodes a RoomInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.RoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.RoomInfo} RoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomInfo message.
         * @function verify
         * @memberof Hallx.RoomInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.id))
                return "id: integer expected";
            if (message.seq != null && message.hasOwnProperty("seq"))
                if (!$util.isInteger(message.seq))
                    return "seq: integer expected";
            if (!$util.isInteger(message.gameFieldId))
                return "gameFieldId: integer expected";
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                if (!$util.isString(message.gameId))
                    return "gameId: string expected";
            if (message.stateInfo != null && message.hasOwnProperty("stateInfo")) {
                var error = $root.Hallx.RoomStateInfo.verify(message.stateInfo);
                if (error)
                    return "stateInfo." + error;
            }
            if (message.headPlayers != null && message.hasOwnProperty("headPlayers")) {
                if (!Array.isArray(message.headPlayers))
                    return "headPlayers: array expected";
                for (var i = 0; i < message.headPlayers.length; ++i) {
                    var error = $root.Hallx.PlayerInfo.verify(message.headPlayers[i]);
                    if (error)
                        return "headPlayers." + error;
                }
            }
            if (message.gameResults != null && message.hasOwnProperty("gameResults")) {
                if (!Array.isArray(message.gameResults))
                    return "gameResults: array expected";
                for (var i = 0; i < message.gameResults.length; ++i) {
                    var error = $root.Hallx.GameResultItem.verify(message.gameResults[i]);
                    if (error)
                        return "gameResults." + error;
                }
            }
            if (message.extraInfo != null && message.hasOwnProperty("extraInfo"))
                if (!$util.isString(message.extraInfo))
                    return "extraInfo: string expected";
            return null;
        };

        /**
         * Creates a RoomInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.RoomInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.RoomInfo} RoomInfo
         */
        RoomInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.RoomInfo)
                return object;
            var message = new $root.Hallx.RoomInfo();
            if (object.id != null)
                message.id = object.id | 0;
            if (object.seq != null)
                message.seq = object.seq | 0;
            if (object.gameFieldId != null)
                message.gameFieldId = object.gameFieldId | 0;
            if (object.gameId != null)
                message.gameId = String(object.gameId);
            if (object.stateInfo != null) {
                if (typeof object.stateInfo !== "object")
                    throw TypeError(".Hallx.RoomInfo.stateInfo: object expected");
                message.stateInfo = $root.Hallx.RoomStateInfo.fromObject(object.stateInfo);
            }
            if (object.headPlayers) {
                if (!Array.isArray(object.headPlayers))
                    throw TypeError(".Hallx.RoomInfo.headPlayers: array expected");
                message.headPlayers = [];
                for (var i = 0; i < object.headPlayers.length; ++i) {
                    if (typeof object.headPlayers[i] !== "object")
                        throw TypeError(".Hallx.RoomInfo.headPlayers: object expected");
                    message.headPlayers[i] = $root.Hallx.PlayerInfo.fromObject(object.headPlayers[i]);
                }
            }
            if (object.gameResults) {
                if (!Array.isArray(object.gameResults))
                    throw TypeError(".Hallx.RoomInfo.gameResults: array expected");
                message.gameResults = [];
                for (var i = 0; i < object.gameResults.length; ++i) {
                    if (typeof object.gameResults[i] !== "object")
                        throw TypeError(".Hallx.RoomInfo.gameResults: object expected");
                    message.gameResults[i] = $root.Hallx.GameResultItem.fromObject(object.gameResults[i]);
                }
            }
            if (object.extraInfo != null)
                message.extraInfo = String(object.extraInfo);
            return message;
        };

        /**
         * Creates a plain object from a RoomInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.RoomInfo
         * @static
         * @param {Hallx.RoomInfo} message RoomInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.headPlayers = [];
                object.gameResults = [];
            }
            if (options.defaults) {
                object.id = 0;
                object.seq = 0;
                object.gameFieldId = 0;
                object.gameId = "";
                object.stateInfo = null;
                object.extraInfo = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.seq != null && message.hasOwnProperty("seq"))
                object.seq = message.seq;
            if (message.gameFieldId != null && message.hasOwnProperty("gameFieldId"))
                object.gameFieldId = message.gameFieldId;
            if (message.gameId != null && message.hasOwnProperty("gameId"))
                object.gameId = message.gameId;
            if (message.stateInfo != null && message.hasOwnProperty("stateInfo"))
                object.stateInfo = $root.Hallx.RoomStateInfo.toObject(message.stateInfo, options);
            if (message.headPlayers && message.headPlayers.length) {
                object.headPlayers = [];
                for (var j = 0; j < message.headPlayers.length; ++j)
                    object.headPlayers[j] = $root.Hallx.PlayerInfo.toObject(message.headPlayers[j], options);
            }
            if (message.gameResults && message.gameResults.length) {
                object.gameResults = [];
                for (var j = 0; j < message.gameResults.length; ++j)
                    object.gameResults[j] = $root.Hallx.GameResultItem.toObject(message.gameResults[j], options);
            }
            if (message.extraInfo != null && message.hasOwnProperty("extraInfo"))
                object.extraInfo = message.extraInfo;
            return object;
        };

        /**
         * Converts this RoomInfo to JSON.
         * @function toJSON
         * @memberof Hallx.RoomInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomInfo;
    })();

    Hallx.RoomInfoNotify = (function() {

        /**
         * Properties of a RoomInfoNotify.
         * @memberof Hallx
         * @interface IRoomInfoNotify
         * @property {Hallx.IRoomInfo} roomInfo RoomInfoNotify roomInfo
         */

        /**
         * Constructs a new RoomInfoNotify.
         * @memberof Hallx
         * @classdesc 房间信息通知
         * 客户端收到此消息后，除roomInfo的id、gameResults字段外,roomInfo的其他字段均使用“存在即设置”的方式更新
         * @implements IRoomInfoNotify
         * @constructor
         * @param {Hallx.IRoomInfoNotify=} [properties] Properties to set
         */
        function RoomInfoNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomInfoNotify roomInfo.
         * @member {Hallx.IRoomInfo} roomInfo
         * @memberof Hallx.RoomInfoNotify
         * @instance
         */
        RoomInfoNotify.prototype.roomInfo = null;

        /**
         * Creates a new RoomInfoNotify instance using the specified properties.
         * @function create
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {Hallx.IRoomInfoNotify=} [properties] Properties to set
         * @returns {Hallx.RoomInfoNotify} RoomInfoNotify instance
         */
        RoomInfoNotify.create = function create(properties) {
            return new RoomInfoNotify(properties);
        };

        /**
         * Encodes the specified RoomInfoNotify message. Does not implicitly {@link Hallx.RoomInfoNotify.verify|verify} messages.
         * @function encode
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {Hallx.IRoomInfoNotify} message RoomInfoNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomInfoNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            $root.Hallx.RoomInfo.encode(message.roomInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RoomInfoNotify message, length delimited. Does not implicitly {@link Hallx.RoomInfoNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {Hallx.IRoomInfoNotify} message RoomInfoNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomInfoNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomInfoNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.RoomInfoNotify} RoomInfoNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomInfoNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.RoomInfoNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomInfo = $root.Hallx.RoomInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("roomInfo"))
                throw $util.ProtocolError("missing required 'roomInfo'", { instance: message });
            return message;
        };

        /**
         * Decodes a RoomInfoNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.RoomInfoNotify} RoomInfoNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomInfoNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomInfoNotify message.
         * @function verify
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomInfoNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            {
                var error = $root.Hallx.RoomInfo.verify(message.roomInfo);
                if (error)
                    return "roomInfo." + error;
            }
            return null;
        };

        /**
         * Creates a RoomInfoNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.RoomInfoNotify} RoomInfoNotify
         */
        RoomInfoNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.RoomInfoNotify)
                return object;
            var message = new $root.Hallx.RoomInfoNotify();
            if (object.roomInfo != null) {
                if (typeof object.roomInfo !== "object")
                    throw TypeError(".Hallx.RoomInfoNotify.roomInfo: object expected");
                message.roomInfo = $root.Hallx.RoomInfo.fromObject(object.roomInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a RoomInfoNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.RoomInfoNotify
         * @static
         * @param {Hallx.RoomInfoNotify} message RoomInfoNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomInfoNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomInfo = null;
            if (message.roomInfo != null && message.hasOwnProperty("roomInfo"))
                object.roomInfo = $root.Hallx.RoomInfo.toObject(message.roomInfo, options);
            return object;
        };

        /**
         * Converts this RoomInfoNotify to JSON.
         * @function toJSON
         * @memberof Hallx.RoomInfoNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomInfoNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomInfoNotify;
    })();

    Hallx.BatchRoomInfosNotify = (function() {

        /**
         * Properties of a BatchRoomInfosNotify.
         * @memberof Hallx
         * @interface IBatchRoomInfosNotify
         * @property {Array.<Hallx.IRoomInfo>|null} [roomInfos] BatchRoomInfosNotify roomInfos
         */

        /**
         * Constructs a new BatchRoomInfosNotify.
         * @memberof Hallx
         * @classdesc 批量房间信息通知
         * 使用方法同上。注意，在客户端建立连接并通过认证后，如果服务端有房间信息首推的就是这个消息。
         * @implements IBatchRoomInfosNotify
         * @constructor
         * @param {Hallx.IBatchRoomInfosNotify=} [properties] Properties to set
         */
        function BatchRoomInfosNotify(properties) {
            this.roomInfos = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BatchRoomInfosNotify roomInfos.
         * @member {Array.<Hallx.IRoomInfo>} roomInfos
         * @memberof Hallx.BatchRoomInfosNotify
         * @instance
         */
        BatchRoomInfosNotify.prototype.roomInfos = $util.emptyArray;

        /**
         * Creates a new BatchRoomInfosNotify instance using the specified properties.
         * @function create
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {Hallx.IBatchRoomInfosNotify=} [properties] Properties to set
         * @returns {Hallx.BatchRoomInfosNotify} BatchRoomInfosNotify instance
         */
        BatchRoomInfosNotify.create = function create(properties) {
            return new BatchRoomInfosNotify(properties);
        };

        /**
         * Encodes the specified BatchRoomInfosNotify message. Does not implicitly {@link Hallx.BatchRoomInfosNotify.verify|verify} messages.
         * @function encode
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {Hallx.IBatchRoomInfosNotify} message BatchRoomInfosNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BatchRoomInfosNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomInfos != null && message.roomInfos.length)
                for (var i = 0; i < message.roomInfos.length; ++i)
                    $root.Hallx.RoomInfo.encode(message.roomInfos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BatchRoomInfosNotify message, length delimited. Does not implicitly {@link Hallx.BatchRoomInfosNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {Hallx.IBatchRoomInfosNotify} message BatchRoomInfosNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BatchRoomInfosNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BatchRoomInfosNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.BatchRoomInfosNotify} BatchRoomInfosNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BatchRoomInfosNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.BatchRoomInfosNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.roomInfos && message.roomInfos.length))
                        message.roomInfos = [];
                    message.roomInfos.push($root.Hallx.RoomInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BatchRoomInfosNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.BatchRoomInfosNotify} BatchRoomInfosNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BatchRoomInfosNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BatchRoomInfosNotify message.
         * @function verify
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BatchRoomInfosNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomInfos != null && message.hasOwnProperty("roomInfos")) {
                if (!Array.isArray(message.roomInfos))
                    return "roomInfos: array expected";
                for (var i = 0; i < message.roomInfos.length; ++i) {
                    var error = $root.Hallx.RoomInfo.verify(message.roomInfos[i]);
                    if (error)
                        return "roomInfos." + error;
                }
            }
            return null;
        };

        /**
         * Creates a BatchRoomInfosNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.BatchRoomInfosNotify} BatchRoomInfosNotify
         */
        BatchRoomInfosNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.BatchRoomInfosNotify)
                return object;
            var message = new $root.Hallx.BatchRoomInfosNotify();
            if (object.roomInfos) {
                if (!Array.isArray(object.roomInfos))
                    throw TypeError(".Hallx.BatchRoomInfosNotify.roomInfos: array expected");
                message.roomInfos = [];
                for (var i = 0; i < object.roomInfos.length; ++i) {
                    if (typeof object.roomInfos[i] !== "object")
                        throw TypeError(".Hallx.BatchRoomInfosNotify.roomInfos: object expected");
                    message.roomInfos[i] = $root.Hallx.RoomInfo.fromObject(object.roomInfos[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BatchRoomInfosNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.BatchRoomInfosNotify
         * @static
         * @param {Hallx.BatchRoomInfosNotify} message BatchRoomInfosNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BatchRoomInfosNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.roomInfos = [];
            if (message.roomInfos && message.roomInfos.length) {
                object.roomInfos = [];
                for (var j = 0; j < message.roomInfos.length; ++j)
                    object.roomInfos[j] = $root.Hallx.RoomInfo.toObject(message.roomInfos[j], options);
            }
            return object;
        };

        /**
         * Converts this BatchRoomInfosNotify to JSON.
         * @function toJSON
         * @memberof Hallx.BatchRoomInfosNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BatchRoomInfosNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BatchRoomInfosNotify;
    })();

    Hallx.OneRoundGameResultNotify = (function() {

        /**
         * Properties of an OneRoundGameResultNotify.
         * @memberof Hallx
         * @interface IOneRoundGameResultNotify
         * @property {number} roomId OneRoundGameResultNotify roomId
         * @property {Hallx.IGameResultItem} gameResult OneRoundGameResultNotify gameResult
         */

        /**
         * Constructs a new OneRoundGameResultNotify.
         * @memberof Hallx
         * @classdesc 一局游戏结果通知，部分游戏会使用该消息
         * @implements IOneRoundGameResultNotify
         * @constructor
         * @param {Hallx.IOneRoundGameResultNotify=} [properties] Properties to set
         */
        function OneRoundGameResultNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OneRoundGameResultNotify roomId.
         * @member {number} roomId
         * @memberof Hallx.OneRoundGameResultNotify
         * @instance
         */
        OneRoundGameResultNotify.prototype.roomId = 0;

        /**
         * OneRoundGameResultNotify gameResult.
         * @member {Hallx.IGameResultItem} gameResult
         * @memberof Hallx.OneRoundGameResultNotify
         * @instance
         */
        OneRoundGameResultNotify.prototype.gameResult = null;

        /**
         * Creates a new OneRoundGameResultNotify instance using the specified properties.
         * @function create
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {Hallx.IOneRoundGameResultNotify=} [properties] Properties to set
         * @returns {Hallx.OneRoundGameResultNotify} OneRoundGameResultNotify instance
         */
        OneRoundGameResultNotify.create = function create(properties) {
            return new OneRoundGameResultNotify(properties);
        };

        /**
         * Encodes the specified OneRoundGameResultNotify message. Does not implicitly {@link Hallx.OneRoundGameResultNotify.verify|verify} messages.
         * @function encode
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {Hallx.IOneRoundGameResultNotify} message OneRoundGameResultNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OneRoundGameResultNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            $root.Hallx.GameResultItem.encode(message.gameResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OneRoundGameResultNotify message, length delimited. Does not implicitly {@link Hallx.OneRoundGameResultNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {Hallx.IOneRoundGameResultNotify} message OneRoundGameResultNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OneRoundGameResultNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OneRoundGameResultNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.OneRoundGameResultNotify} OneRoundGameResultNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OneRoundGameResultNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.OneRoundGameResultNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                case 2:
                    message.gameResult = $root.Hallx.GameResultItem.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("roomId"))
                throw $util.ProtocolError("missing required 'roomId'", { instance: message });
            if (!message.hasOwnProperty("gameResult"))
                throw $util.ProtocolError("missing required 'gameResult'", { instance: message });
            return message;
        };

        /**
         * Decodes an OneRoundGameResultNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.OneRoundGameResultNotify} OneRoundGameResultNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OneRoundGameResultNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OneRoundGameResultNotify message.
         * @function verify
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OneRoundGameResultNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.roomId))
                return "roomId: integer expected";
            {
                var error = $root.Hallx.GameResultItem.verify(message.gameResult);
                if (error)
                    return "gameResult." + error;
            }
            return null;
        };

        /**
         * Creates an OneRoundGameResultNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.OneRoundGameResultNotify} OneRoundGameResultNotify
         */
        OneRoundGameResultNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.OneRoundGameResultNotify)
                return object;
            var message = new $root.Hallx.OneRoundGameResultNotify();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            if (object.gameResult != null) {
                if (typeof object.gameResult !== "object")
                    throw TypeError(".Hallx.OneRoundGameResultNotify.gameResult: object expected");
                message.gameResult = $root.Hallx.GameResultItem.fromObject(object.gameResult);
            }
            return message;
        };

        /**
         * Creates a plain object from an OneRoundGameResultNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.OneRoundGameResultNotify
         * @static
         * @param {Hallx.OneRoundGameResultNotify} message OneRoundGameResultNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OneRoundGameResultNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomId = 0;
                object.gameResult = null;
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.gameResult != null && message.hasOwnProperty("gameResult"))
                object.gameResult = $root.Hallx.GameResultItem.toObject(message.gameResult, options);
            return object;
        };

        /**
         * Converts this OneRoundGameResultNotify to JSON.
         * @function toJSON
         * @memberof Hallx.OneRoundGameResultNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OneRoundGameResultNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OneRoundGameResultNotify;
    })();

    Hallx.RoomClosedNotify = (function() {

        /**
         * Properties of a RoomClosedNotify.
         * @memberof Hallx
         * @interface IRoomClosedNotify
         * @property {Array.<number>|null} [roomIds] RoomClosedNotify roomIds
         */

        /**
         * Constructs a new RoomClosedNotify.
         * @memberof Hallx
         * @classdesc 房间关闭通知
         * 客户端收到此消息后，清除相应的房间信息
         * @implements IRoomClosedNotify
         * @constructor
         * @param {Hallx.IRoomClosedNotify=} [properties] Properties to set
         */
        function RoomClosedNotify(properties) {
            this.roomIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomClosedNotify roomIds.
         * @member {Array.<number>} roomIds
         * @memberof Hallx.RoomClosedNotify
         * @instance
         */
        RoomClosedNotify.prototype.roomIds = $util.emptyArray;

        /**
         * Creates a new RoomClosedNotify instance using the specified properties.
         * @function create
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {Hallx.IRoomClosedNotify=} [properties] Properties to set
         * @returns {Hallx.RoomClosedNotify} RoomClosedNotify instance
         */
        RoomClosedNotify.create = function create(properties) {
            return new RoomClosedNotify(properties);
        };

        /**
         * Encodes the specified RoomClosedNotify message. Does not implicitly {@link Hallx.RoomClosedNotify.verify|verify} messages.
         * @function encode
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {Hallx.IRoomClosedNotify} message RoomClosedNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomClosedNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomIds != null && message.roomIds.length)
                for (var i = 0; i < message.roomIds.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomIds[i]);
            return writer;
        };

        /**
         * Encodes the specified RoomClosedNotify message, length delimited. Does not implicitly {@link Hallx.RoomClosedNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {Hallx.IRoomClosedNotify} message RoomClosedNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomClosedNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomClosedNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.RoomClosedNotify} RoomClosedNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomClosedNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.RoomClosedNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.roomIds && message.roomIds.length))
                        message.roomIds = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.roomIds.push(reader.int32());
                    } else
                        message.roomIds.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomClosedNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.RoomClosedNotify} RoomClosedNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomClosedNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomClosedNotify message.
         * @function verify
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomClosedNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomIds != null && message.hasOwnProperty("roomIds")) {
                if (!Array.isArray(message.roomIds))
                    return "roomIds: array expected";
                for (var i = 0; i < message.roomIds.length; ++i)
                    if (!$util.isInteger(message.roomIds[i]))
                        return "roomIds: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a RoomClosedNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.RoomClosedNotify} RoomClosedNotify
         */
        RoomClosedNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.RoomClosedNotify)
                return object;
            var message = new $root.Hallx.RoomClosedNotify();
            if (object.roomIds) {
                if (!Array.isArray(object.roomIds))
                    throw TypeError(".Hallx.RoomClosedNotify.roomIds: array expected");
                message.roomIds = [];
                for (var i = 0; i < object.roomIds.length; ++i)
                    message.roomIds[i] = object.roomIds[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a RoomClosedNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.RoomClosedNotify
         * @static
         * @param {Hallx.RoomClosedNotify} message RoomClosedNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomClosedNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.roomIds = [];
            if (message.roomIds && message.roomIds.length) {
                object.roomIds = [];
                for (var j = 0; j < message.roomIds.length; ++j)
                    object.roomIds[j] = message.roomIds[j];
            }
            return object;
        };

        /**
         * Converts this RoomClosedNotify to JSON.
         * @function toJSON
         * @memberof Hallx.RoomClosedNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomClosedNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomClosedNotify;
    })();

    Hallx.Quit = (function() {

        /**
         * Properties of a Quit.
         * @memberof Hallx
         * @interface IQuit
         */

        /**
         * Constructs a new Quit.
         * @memberof Hallx
         * @classdesc 退出游戏大厅，断开连接
         * @implements IQuit
         * @constructor
         * @param {Hallx.IQuit=} [properties] Properties to set
         */
        function Quit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Quit instance using the specified properties.
         * @function create
         * @memberof Hallx.Quit
         * @static
         * @param {Hallx.IQuit=} [properties] Properties to set
         * @returns {Hallx.Quit} Quit instance
         */
        Quit.create = function create(properties) {
            return new Quit(properties);
        };

        /**
         * Encodes the specified Quit message. Does not implicitly {@link Hallx.Quit.verify|verify} messages.
         * @function encode
         * @memberof Hallx.Quit
         * @static
         * @param {Hallx.IQuit} message Quit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Quit.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Quit message, length delimited. Does not implicitly {@link Hallx.Quit.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Hallx.Quit
         * @static
         * @param {Hallx.IQuit} message Quit message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Quit.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Quit message from the specified reader or buffer.
         * @function decode
         * @memberof Hallx.Quit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Hallx.Quit} Quit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Quit.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Hallx.Quit();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Quit message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Hallx.Quit
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Hallx.Quit} Quit
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Quit.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Quit message.
         * @function verify
         * @memberof Hallx.Quit
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Quit.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Quit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Hallx.Quit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Hallx.Quit} Quit
         */
        Quit.fromObject = function fromObject(object) {
            if (object instanceof $root.Hallx.Quit)
                return object;
            return new $root.Hallx.Quit();
        };

        /**
         * Creates a plain object from a Quit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Hallx.Quit
         * @static
         * @param {Hallx.Quit} message Quit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quit.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Quit to JSON.
         * @function toJSON
         * @memberof Hallx.Quit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Quit;
    })();

    return Hallx;
})();

module.exports = $root;
